import {getMetricIdentifiersFromExpressions} from '../../../util/plotHelpers/plotHelpers';
import {LineConfig} from '../config/types';
import {
  evaluateExpression,
  Expression,
  metricsInExpression,
} from './../../../util/expr';
import {Line} from './../../../util/plotHelpers';
import {SupplementalMetricsByRun} from './types';

export function convertLineDataToTimestamp(lines: Line[]) {
  lines.forEach(line => {
    line.data.forEach(p => {
      p.x = p.x * 1000;
    });
  });
}

/**
 * Evaluate the x expression for each point in the line
 */
export function evaluateXExpressions(
  expression: Expression,
  lines: Line[],
  supplementalMetricsByRun: SupplementalMetricsByRun
) {
  try {
    lines.forEach(line => {
      line.data.forEach(p => {
        p.x = evaluateExpression(expression, {
          ...supplementalMetricsByRun[line.name!],
          ...(p as Record<string, any>),
        });
      });
    });
  } catch (e) {
    console.error('Error evaluating x expression', e);
  }
}

/**
 * Any line with a single point where y !== y0 has a valid area to be displayed
 */
export function removeUselessAreaLines(lines: Line[]) {
  return lines.filter(l => {
    if (l.meta.type !== 'area') {
      return true;
    }

    return l.data.some(p => p.y !== p.y0);
  });
}

export function determineXMetrics(
  lineConfig: Pick<LineConfig, 'xAxis' | 'xExpression'>
) {
  const xExpressionMetricIdentifiers = lineConfig.xExpression
    ? metricsInExpression(lineConfig.xExpression, false)
    : [];

  return [
    ...new Set(
      [
        ...xExpressionMetricIdentifiers.concat(lineConfig.xAxis, '_step'),
      ].filter(metric => !!metric)
    ),
  ];
}

export function determineYMetrics(
  lineConfig: Pick<LineConfig, 'yAxis' | 'expressions' | 'xExpression'>
) {
  const {expressionMetricIdentifiers} = getMetricIdentifiersFromExpressions(
    lineConfig.expressions,
    lineConfig.xExpression
  );

  return [
    ...new Set(
      [...lineConfig.yAxis.concat(expressionMetricIdentifiers)].filter(
        metric => !!metric
      )
    ),
  ];
}
